import { useLingui } from "@lingui/react/macro";

import { useHeroLookup } from "@/features/matches";

import { formatClock } from "../../model/formatClock";
import type { HighlightView } from "../../model/Highlight";

// Строка «Victor · 1 нояб. · 16:14»: герой, день матча, время момента в матче.
export const useHighlightMeta = (): ((highlight: HighlightView) => string) => {
  const { i18n } = useLingui();
  const hero = useHeroLookup();
  const day = new Intl.DateTimeFormat(i18n.locale, { day: "numeric", month: "short" });
  return (highlight) =>
    [
      hero(highlight.hero_id).name,
      highlight.started_at === null ? null : day.format(new Date(highlight.started_at)),
      formatClock(highlight.game_time_s),
    ]
      .filter((part) => part !== null)
      .join(" · ");
};
